import { Meta } from "../../../meta/meta";
import { useTranslation } from "react-i18next";
import { GoBack } from "../../../components/ui/goBack";
import {
  getYouTubeEmbedUrl,
  removeFileExtensions,
} from "../../../utils/formatters";
import { getDownload } from "../../../utils/helpers";
import { isNotEmptyArray } from "../../../utils/checkers";
import { useParams } from "react-router-dom";
import { useTanstackById } from "../../../hooks/useTanstack";
import { Loader } from "../../../components/ui/loader";
import styles from "../../template/models/styles.module.scss";

const NewsModelThree = ({
  id,
  title_am,
  title_en,
  description_am,
  description_en,
  image,
}) => {
  const { t } = useTranslation();
  const { language } = useParams();
  const { data } = useTanstackById("getWebSingleNews", id);

  const title = language === "am" ? title_am : title_en;
  const description = language === "am" ? description_am : description_en;

  return (
    <>
      <Meta title={title} description={description} image={image} />
      {!data ? (
        <Loader />
      ) : (
        <main className={styles.modelThree}>
          <div className="container">
            <div className={styles.modelThree_context}>
              <GoBack />

              <div className={styles.modelThree_main}>
                <div className={styles.modelThree_main_column}>
                  {data?.images?.length ? (
                    <div className={styles.modelThree_main_column_img}>
                      <img src={data?.images[0]} alt="mianImg" loading="lazy" />
                      <span
                        className={styles.modelThree_main_column_img_imageDate}
                      >
                        {data?.created}
                      </span>
                    </div>
                  ) : null}

                  <h1>{data?.title}</h1>

                  <div className={styles.modelThree_updateBlockSecond}>
                    <div className={styles.modelThree_updateSecond}>
                      <p>{t("update")}</p>
                      <span>{data?.updated}</span>
                    </div>
                  </div>

                  <div
                    className={styles.modelThree_main_column_text}
                    dangerouslySetInnerHTML={{ __html: data?.description }}
                  ></div>

                  {data?.files?.length ? (
                    <ul className={styles.model_files}>
                      {data?.files?.map(({ name, stored_name }) => {
                        return (
                          <li key={name} onClick={() => getDownload(name)}>
                            {removeFileExtensions(stored_name)}
                          </li>
                        );
                      })}
                    </ul>
                  ) : null}

                  {isNotEmptyArray(data?.links) ? (
                    <ul className={styles.model_links}>
                      {data?.links?.map((el) => {
                        const isYouTubeLink =
                          el?.includes("youtube.com") ||
                          el?.includes("youtu.be");
                        const embedUrl = getYouTubeEmbedUrl(el);

                        return (
                          <li key={el}>
                            {isYouTubeLink ? (
                              <iframe
                                width="100%"
                                // width={mobile ? "100%" : "560"}
                                height="315"
                                src={embedUrl}
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                                title="YouTube video"
                              ></iframe>
                            ) : (
                              <a href={el} target="/blank" rel="noreferrer">
                                {el}
                              </a>
                            )}
                          </li>
                        );
                      })}
                    </ul>
                  ) : null}
                </div>

                <div className={styles.modelThree_updateBlockFirst}>
                  <div className={styles.modelThree_updateFirst}>
                    <p>{t("update")}</p>
                    <span>{data?.updated}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      )}
    </>
  );
};

export default NewsModelThree;
